import { createFileRoute } from "@tanstack/react-router";
import Impressum from "@/pages/Impressum";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/impressum")({
  head: () =>
    seoHead({
      title: "Impressum | Clicks DMP",
      description:
        "Impressum von Clicks DMP – Design & Media Production, Inhaber Ashraf AlSalaita, Karl-Traub-Straße 15, 68199 Mannheim.",
      path: "/impressum",
    }),
  component: Impressum,
});
